module.exports = __webpack_public_path__ + "static/img/setting.882f234e.svg";